import React, { FunctionComponent, useRef, useState } from 'react';
import { Popover, Typography } from '@material-ui/core';
import { ExclamationIcon } from 'app/assets/images/icons';
import styles from './ItemPopperCell.module.scss';
import { makeStyles } from '@material-ui/core/styles';
import { nFormatter } from 'app/utils/numbersFormater';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { _t } from 'app/utils/i18n';
import { checkTranslated } from 'app/utils/helpers';
import { handelNameKey } from 'app/utils/handel-name-key';
import { path } from 'app/utils/path';
import { dateTimeFormatter } from 'app/utils/dateTimeFormatter';

interface Props {
  item?: any;
  onClickFilter?: (
    filterName: string,
  ) => (val: [{ label: string; value: number | string }]) => Promise<any>;
  onSubmit?: () => void;
  data?: any;
  filterName?: string;
  keyName?: string | number;
  headers?: string[];
  text?: string | number;
  format?: boolean;
  itemKey?: string;
  isTrashed?: boolean;
  smallPopper?: boolean;
  seeAllLink?: string;
  currentModule?: string;
  moreSize?: boolean;
  isOrganization?: boolean;
  countryRank?: boolean;
  reportSchedule?: boolean;
  showIfLessThan2?: boolean;
  isClickable?: boolean;
  clickFn?: (platform: string) => void;
}
const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  popoverContent: {
    pointerEvents: 'auto',
  },
  paper: {
    padding: theme.spacing(0),
  },
}));

const ItemPopperCell: FunctionComponent<Props> = ({
  data,
  reportSchedule,
  item,
  headers,
  keyName,
  filterName,
  onClickFilter,
  onSubmit,
  text,
  format,
  itemKey = 'mentions',
  isTrashed,
  smallPopper,
  seeAllLink,
  currentModule,
  moreSize,
  isOrganization,
  countryRank,
  showIfLessThan2,
  clickFn,
  isClickable,
}) => {
  const isFormatted = (unFormattedItem: string | number) =>
    format && !isNaN(unFormattedItem as any)
      ? nFormatter(Number(unFormattedItem))
      : unFormattedItem;
  const classes = useStyles();
  const moduleName = useLocation();
  const { pathname } = moduleName;
  const [openedPopover, setOpenedPopover] = useState(false);
  const popoverAnchor = useRef(null);

  const popoverEnter = () => {
    setOpenedPopover(true);
  };

  const popoverLeave = () => {
    setOpenedPopover(false);
  };
  const history = useHistory();
  const isDataObjArray = Array.isArray(data);
  const isItemArray = Array.isArray(item);
  const isItemObjOrString = item && typeof item?.[0] === 'string';
  const clickableItem = isItemArray
    ? isItemObjOrString
      ? item?.[0]
      : keyName != undefined && item?.[0]?.[keyName]
    : item;

  const deepCheckItem = (item: string | number) =>
    (typeof item === 'string' && item.length !== 0) || typeof item === 'number'
      ? true
      : false;

  const checkNumber = (n: string) => {
    return typeof n === 'undefined' || isNaN(+n) || n?.length < 1
      ? true
      : !!+n && +n !== 0;
  };
  return (
    <div
      className={`${styles.ItemPopperCell} ${
        isTrashed ? styles.ItemPopperCell__Trashed : ''
      }`}
      // dir="auto"
    >
      {onClickFilter ? (
        <Typography
          className={styles.clickable}
          onClick={async () => {
            await onClickFilter(filterName || '')([
              { label: item?.[0]?.name, value: item?.[0]?.id },
            ]);
            onSubmit?.();
          }}
          variant="body2"
          component={'span'}
          style={{ fontSize: '10px' }}
        >
          {isFormatted(clickableItem)}
        </Typography>
      ) : (
        <Typography
          dir="auto"
          onClick={() =>
            isOrganization
              ? history.push({
                  pathname: path.organization.ORGANIZATION_TABLE,
                  state: {
                    filter: 'industries',
                    data: data?.[0],
                  },
                })
              : null
          }
          variant="body2"
          component={'span'}
          style={{ fontSize: '10px' }}
        >
          {deepCheckItem(item)
            ? item?.length > 20
              ? `${item?.slice(0, 20)} ...`
              : data.length === 1
                ? item
                : ''
            : deepCheckItem(isFormatted(clickableItem))
              ? isFormatted(clickableItem)?.toString()?.length > 20
                ? `${isFormatted(clickableItem)?.toString()?.slice(0, 20)} ...`
                : data.length === 1
                  ? isFormatted(clickableItem)
                  : ''
              : ''}
        </Typography>
      )}
      {text && checkNumber(text as string) ? (
        <span>{isFormatted(text)}</span>
      ) : text !== undefined ? (
        <>_</>
      ) : (
        <> </>
      )}
      {!pathname.includes('influencers') &&
        data?.length === 1 &&
        !showIfLessThan2 &&
        !countryRank &&
        !item &&
        !text && (
          <span className={`truncate-text`}>
            {data?.[0]?.name
              ? handelNameKey(data?.[0]?.name)
              : checkTranslated(data?.[0]?.original, data?.[0]?.arabic)}
          </span>
        )}
      {(data?.length === 0 || !data) && text == undefined && <p>-</p>}
      {(countryRank &&
        data &&
        data?.length >= 1 &&
        checkNumber(text as string)) ||
      (data &&
        (data?.length > 1 || (showIfLessThan2 && data?.length > 0)) &&
        !countryRank &&
        checkNumber(text as string)) ? (
        <>
          <div style={{ display: 'flex', cursor: 'pointer' }}>
            <span
              ref={popoverAnchor}
              aria-owns="mouse-over-popover"
              aria-haspopup="true"
              onMouseEnter={popoverEnter}
              onMouseLeave={popoverLeave}
              style={{ marginBottom: '-3px' }}
              data-testid="exclamation-icon"
            >
              <ExclamationIcon />
            </span>
          </div>
          <Popover
            id="mouse-over-popover"
            className={classes.popover}
            classes={{
              paper: classes.popoverContent,
            }}
            open={openedPopover}
            anchorEl={popoverAnchor.current}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            PaperProps={{
              onMouseEnter: popoverEnter,
              onMouseLeave: popoverLeave,
            }}
            disableRestoreFocus
          >
            <div
              className={`${styles.popper} ${
                smallPopper ? styles.smallPopper : ''
              }`}
              data-moresize={moreSize ? true : false}
            >
              {data && headers && (
                <div className={styles.popperItemHeader}>
                  <span>{headers?.[0]}</span>
                  {headers?.[1] ? <span>{headers?.[1]}</span> : null}
                </div>
              )}
              {data && isDataObjArray
                ? data?.map((item: any, index) => {
                    if (typeof item === 'string') {
                      return <p key={item}>{item}</p>;
                    }
                    if (isItemObjOrString) {
                      return (
                        <div
                          data-testid="country-cell-popper-item"
                          key={
                            typeof item === 'string'
                              ? item
                              : item?.name || item?.label
                          }
                          className={styles.popperItem}
                          onClick={() =>
                            isOrganization
                              ? history.push({
                                  pathname:
                                    path.organization.ORGANIZATION_TABLE,
                                  state: {
                                    filter: 'industries',
                                    data: data?.[index],
                                  },
                                })
                              : null
                          }
                          style={{
                            cursor: isOrganization ? 'pointer' : undefined,
                          }}
                        >
                          <p dir="auto">
                            {item?.name?.length > 20 || item?.label?.length > 20
                              ? `${
                                  item?.name?.slice(0, 20) ||
                                  item?.label?.slice(0, 20)
                                } ...`
                              : item?.name || item?.label}
                          </p>
                          {deepCheckItem(item?.followersCount) &&
                            headers &&
                            headers?.length > 1 && (
                              <p>
                                {isNaN(item.followersCount)
                                  ? item.followersCount
                                  : nFormatter(item.followersCount)}
                              </p>
                            )}
                        </div>
                      );
                    }
                    return (
                      <div
                        data-testid="country-cell-popper-item"
                        key={index}
                        className={styles.popperItem}
                      >
                        {deepCheckItem(item?.title) && <p> {item.title}</p>}
                        {deepCheckItem(item?.name) && (
                          <p>{handelNameKey(item.name)}</p>
                        )}
                        {deepCheckItem(item?.label) && <p>{item.label}</p>}
                        {deepCheckItem(item?.rank) && (
                          <p>
                            {item.rank === 1000
                              ? '-'
                              : isNaN(item.rank)
                                ? item.rank
                                : nFormatter(item.rank)}
                          </p>
                        )}
                        {deepCheckItem(item?.count) && (
                          <p>
                            {isNaN(item.count)
                              ? item.count
                              : nFormatter(item.count)}
                          </p>
                        )}

                        {deepCheckItem(item[itemKey]) && (
                          <p
                            style={{
                              cursor: isClickable ? 'pointer' : undefined,
                            }}
                            onClick={
                              isClickable
                                ? () => clickFn?.(item.name)
                                : undefined
                            }
                          >
                            {isNaN(item[itemKey])
                              ? itemKey === 'date'
                                ? dateTimeFormatter.date(item[itemKey])
                                : item[itemKey]
                              : nFormatter(item[itemKey])}
                          </p>
                        )}
                        {(item?.original || item?.arabic) && (
                          <p>
                            {checkTranslated(item?.original, item?.arabic)
                              ?.length > 21
                              ? `${checkTranslated(
                                  item?.original,
                                  item?.arabic,
                                ).slice(0, 21)} ...`
                              : checkTranslated(item.original, item?.arabic)}
                          </p>
                        )}
                      </div>
                    );
                  })
                : data}
              {seeAllLink && (
                <Link
                  className={styles.seeAll}
                  to={{
                    pathname: seeAllLink,
                    state: {
                      currentModule: currentModule && currentModule,
                      data: data && data,
                    },
                  }}
                >
                  <p>{_t('hashtags:See_all')} </p>
                </Link>
              )}
            </div>
          </Popover>
        </>
      ) : null}
      {data && pathname.includes('reports') && reportSchedule && (
        <>
          {data?.email_subject?.length > 0 ||
          data?.email_interval?.length > 0 ||
          data?.days_of_week?.length > 0 ? (
            <>
              <div style={{ display: 'flex' }}>
                <span
                  ref={popoverAnchor}
                  aria-owns="mouse-over-popover"
                  aria-haspopup="true"
                  onMouseEnter={popoverEnter}
                  onMouseLeave={popoverLeave}
                  style={{ marginBottom: '-3px' }}
                >
                  <ExclamationIcon />
                </span>
              </div>
              <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                  paper: classes.popoverContent,
                }}
                open={openedPopover}
                anchorEl={popoverAnchor.current}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                PaperProps={{
                  onMouseEnter: popoverEnter,
                  onMouseLeave: popoverLeave,
                }}
                disableRestoreFocus
              >
                {data?.email_subject ? (
                  <div className={`${styles.popper}`}>
                    <div className={styles.popperItemHeader}>
                      <p>{_t('reports:email_title')}</p>
                    </div>
                    <p>{data?.email_subject}</p>
                  </div>
                ) : null}
                {data?.email_interval ? (
                  <div className={`${styles.popper}`}>
                    <div className={styles.popperItemHeader}>
                      <p>{_t('reports:email_interval')}</p>
                    </div>
                    <p>{data?.email_interval}</p>
                  </div>
                ) : null}
                {data?.day_of_month > 0 ? (
                  <div className={`${styles.popper}`}>
                    <div className={styles.popperItemHeader}>
                      <p>{_t('reports:day_of_month')}</p>
                    </div>
                    <p> {data?.day_of_month}</p>
                  </div>
                ) : null}
                {data?.days_of_week?.length > 0 ? (
                  <div className={`${styles.popper}`}>
                    <div className={styles.popperItemHeader}>
                      <p>{_t('reports:days_of_Week')}</p>
                    </div>
                    <p> {data?.days_of_week?.join(', ')}</p>
                  </div>
                ) : null}
              </Popover>
            </>
          ) : null}
        </>
      )}
    </div>
  );
};

export default ItemPopperCell;
